<template>
	<div class="myOrder">
		<Tou></Tou>
		<el-breadcrumb class="w1500 pt-30" separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
			<el-breadcrumb-item :to="{ path: '/pointsMall' }">pointsMall</el-breadcrumb-item>
			<el-breadcrumb-item>myOrder</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="w1500 bj-0 p-60 mt-30 mb-60 orderBox">

			<div class="tit flex order_anniu" style="justify-content: space-between;">
				<div class="montserRegular tit-30 biaotie flex a-center mr-20"> <span class="mr-20"></span> My Order
				</div>
				<div class="flex mt-15" style="display: block;">
					<div class="userreplies-right-btn tit-16 cur_pointer z-878787 B-300 mr-15" @click="Shai(0)" :class="orderindex==0?'repliesxuan':''">Gifts</div>
					<div class="userreplies-right-btn tit-16 cur_pointer z-878787 B-300 "  @click="Shai(1)" :class="orderindex==1?'repliesxuan':''">Extended warranty service</div>
				</div>
			</div>

			<div class="flex a-center pb-40 mt-40 j-between flex-wrap contrls">
				<div class="time flex a-center flex-wrap">
					<span class="tit-20 mr-15">Time filter:</span>
					<!-- <el-date-picker class="xuanzeqi" :append-to-body="false" v-model="value" type="daterange"
						range-separator="~" start-placeholder="start date" end-placeholder="ending date">
					</el-date-picker> -->
					<!-- <el-date-picker  class="xuanzeqi" :append-to-body="false" v-model="sos.keywords" type="datetime" placeholder="Select date and time">
					</el-date-picker> -->
					<el-select @change="xuandas" v-model="value" placeholder="please select">
						<el-option v-for="item in datads" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>
				<div class="flex j-between w30 resou-sign">
					<div class="flex">
						<div class="iconfont icon-sousuo pl-20 tit-24 flex a-center" style="color:#717172">
						</div>
						<el-input class="resou_souinput" v-model="sos.keyword" placeholder="Search keywords"
							placeholder-class="tit-16"  placeholder-style="color:#757575;"></el-input>
					</div>
					<div class="btn cur_pointer t-center tit-15" @click="send">Search</div>
				</div>
			</div>
			<div class="br-10 pt-40 pb-40 pl-33 pr-33 liebs mb-45" style="background: #F6F6F8;" v-for="(l,i) in orderlie" v-if="orderindex==1">
				<div class="flex a-center j-between flex-wrap mb-20">
					<div class="tit-20 ys-33 B-normal" style="word-break: break-all;">
						<span style="flex-shrink: 0;">Order Number: </span> 
						<i style="color: #888888;"v-if="l.id">{{l.id}}</i> 
						<i v-else>{{l.orderTypeEnum}}
					</i></div>
					<div class="flex a-center tit-16 ys-66"> <i class="iconfont icon-shijian1 mr-10"></i>{{l.createTime}}
					</div>
				</div>
				<div class="flex a-center">
					<img class="tup mr-50" :src="l.integralCommodityImage" v-if="l.integralCommodityImage && l.type!=4"/>
					<!-- <img class="tup" src="" v-else/> -->
					<div class=" tit-20">
						<div class="mb-10" v-if="l.name && orderindex==1">Extended warranty service:{{l.name}}</div>
						<div class="mb-10" v-if="l.serialNumber && orderindex==1" >Serial Number:{{l.serialNumber}}</div>
						<div class="mb-10" v-if="l.partsWarrantyValidTill && orderindex==1" >PARTS WARRANTY VALID TILL:{{l.partsWarrantyValidTill}}</div>
						<div class="mb-10" v-if="l.standardWarrantyValidTill && orderindex==1" >Limited Warranty valid till:{{l.standardWarrantyValidTill}}</div>
						<div class=" montserRegular" style="color: #E60012;">{{l.point}} points</div>
					</div>
				</div>
			</div>
			<div class="br-10 pt-25 pb-25 pl-33 pr-33 liebs mb-30" style="background: #F6F6F8;" v-for="(l,i) in orderlie" v-else>
				<div class="flex a-center j-between flex-wrap mb-20">
					<div class="tit-20 ys-33 B-normal" style="word-break: break-all;">
						<span style="flex-shrink: 0;">Order Number: </span> 
						<i style="color: #888888;"v-if="l.id">{{l.id}}</i> 
						<i v-else>{{l.orderTypeEnum}}
					</i></div>
					<div class="flex a-center tit-16 ys-66"> <i class="iconfont icon-shijian1 mr-10"></i>{{l.createTime}}
					</div>
				</div>
				<div class="flex a-center">
					<img class="tup mr-50" :src="l.integralCommodityImage" v-if="l.integralCommodityImage && l.type!=4"/>
					<!-- <img class="tup" src="" v-else/> -->
					<div class=" tit-20">
						<div class="" v-if="l.gift">{{l.gift}}</div>
						<div v-if="l.code">code:{{l.code}}</div>
						<div class=" montserRegular" style="color: #E60012;">{{l.point}} points</div>
					</div>
				</div>
			</div>
			<el-pagination class="flex j-center mt-20" 
				@current-change="handleCurrentChange" :current-page.sync="sos.ye" :page-size="sos.jitiao"
				layout="prev, pager, next, jumper,slot" :total="zongshu">
				<span class="ml-10 cur_pointer" @click="goToPage">go</span>
			</el-pagination>

		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Tou from '../../../zuzuzu/touss.vue'
	import Foot from '../../../zuzuzu/foot.vue'
	import {
		duihuanjilu,ybduihuanjilu
	} from '@/api/PointsMall.js';
	export default {
		data() {
			return {
				so: {},
				sos: {
					ye: 1,
					jitiao: 10,
					keyword: "",
					day:0
				},
				value: '',
				zongshu: 10,
				orderindex:1,
				orderlie: [],
				datads: [{
					label: 'All',
					value: '0'
				}, {
					label: 'Within a day',
					value: '1'
				}, {
					label: 'Within a week',
					value: '2'
				}, {
					label: 'Within a week',
					value: '3'
				}, {
					label: 'Within a year',
					value: '4'
				}],
			}
		},
		components: {
			Tou,
			Foot,
		},
		created() {
			if(this.orderindex==1){
				this.yalie()
			}else{
				this.duilies()
				
			}
		
		},
		methods: {
			yalie(){
				ybduihuanjilu({pageNum:this.sos.ye,pageSize:this.sos.jitiao}).then(s=>{
					this.orderlie = s.data.content
					this.zongshu=Number(s.data.totalElements)
				})
			},
			duilies() {
				duihuanjilu({
					"keyword":this.sos.keyword,
					"pageNum": this.sos.ye - 1,
					"pageSize": this.sos.jitiao,
					"day":this.sos.day
				}).then(s => {
					if (s.data.content) {
						this.orderlie = s.data.content
						this.zongshu=Number(s.data.totalElements)
					} else {
						this.$confirm(s.message).then(_ => {
							// this.$dakai('login_in')
							// this.$message({
							//   showClose: true,
							//   iconClass:'el-icon-warning',
							//   customClass:'my-error-message',
							//  dangerouslyUseHTMLString: true,
							//  message:'<strong><i style="margin-left:.1rem;">Please log in first</i> <a href="https://community.goodwe.com/login_in" style="color:red;margin-left:4px;text-decoration: none;">[here]</i> </strong>',
							//   type: 'error',
							//   offset:'350',
							//   duration:0,
							//   iconClass:'el-icon-warning'
							// });
							this.$alert('Please log in first', '', {
							  confirmButtonText: 'Log in',
							  confirmButtonClass:'Loginanniu',
							  distinguishCancelAndClose:true,
							  center:true,
							  roundButton:true,
							  callback: action => {
								  if(action=='confirm'){
										this.$dakai('/login_in')
								  }
							  }
							});
						})
					}
				})
			},
			handleCurrentChange(e) {
				this.duilies()
			},
			Shai(e){
				this.orderindex=e
				if(e==1){
					this.yalie()
				}else{
					this.duilies()
				}
			},
			goToPage() {
				this.handleCurrentChange(this.sos.ye)
			},
			send() {
				this.duilies()
			},
			xuandas(e){
				this.sos.day=e
				this.duilies()
			}
			
		}
	}
</script>

<style lang="scss" scoped>
	.myOrder {
		.z-878787{
			color:#878787
		}
		.z-E60012 {
			color: #E60012;
		}
		.biaotie span {
			display: inline-block;
			width: .08rem;
			height: .28rem;
			background: #e60012;
			border-radius: 4px;
		}
		::v-deep .userreplies-right-btn{
			display: inline-block;
			padding: .1rem .30rem;
			border-radius: 100px;
			// border: 1px solid #e50012;
			box-sizing: border-box;
			background: #ececec;
			
		}
		::v-deep .repliesxuan{
			background: linear-gradient(-31deg,#e70a16 0%, #ff785c 100%);
			color: #fff;
			padding: .1rem .30rem;
		}
		.xuanzeqi {
			&>::v-deep .el-input__inner {
				background: #f6f6f8;
				border-radius: 25px;
			}

			::v-deep .el-input.is-active .el-input__inner {
				border-color: #E71218;
			}

			::v-deep .el-input__inner:focus {
				border-color: #E71218;
			}

			::v-deep .el-date-table td.current:not(.disabled) span {
				background-color: #E71218;
				color: #fff;
			}

			::v-deep .el-date-table td.today span {
				background-color: #E71218;
				color: #fff;
			}

			::v-deep .el-date-table td.available:hover {
				color: #e60012;
			}

			::v-deep .el-date-picker__header-label.active {
				color: #e70a16;
			}

			::v-deep .el-date-picker__header-label:hover {
				color: #e70a16;
			}

			::v-deep .el-year-table td .cell:hover {
				color: #e70a16;
			}

			::v-deep .el-year-table td.current:not(.disabled) .cell {
				color: #e70a16;
			}

			::v-deep .el-year-table td.today .cell {
				color: #e70a16;
			}

			::v-deep .el-month-table td .cell:hover {
				color: #e70a16;
			}

			::v-deep .el-month-table td.current:not(.disabled) .cell {
				color: #e70a16;
			}

			::v-deep .el-button--text {
				color: #e70a16;
			}

			::v-deep .el-button.is-plain:focus {
				border-color: #e70a16;
				color: #e70a16;
			}

			::v-deep .el-button.is-plain:hover {
				border-color: #e70a16;
				color: #e70a16;
			}

			::v-deep .el-time-panel__btn.confirm {
				color: #e70a16;
			}

		}

		::v-deep .resou-sign {
			height: .50rem;
			min-height: 40px;
			border-radius: 100px;
			overflow: hidden;
			background: #F6F6F8;
			min-width: 260px;

			.btn {
				display: flex;
				align-items: center;
				border-radius: 50px;
				padding: 0;
				padding: 0 .32rem;
				background: linear-gradient(87deg, #ff785c 0%, #e70a16 100%);
			}

			.el-input__inner {
				height: 100%;
				padding-left: .1rem;
			}

			.el-input__icon {
				display: flex;
				align-items: center;
			}

			.el-input__prefix {
				font-size: .24rem;
				left: .2rem;
			}

			.resou_souinput .el-input__inner {
				border: none !important;
				background: none !important;
			}

			.resou_souinput input::placeholder {
				color: #c6c6c6;
				font-family: "montserLight";
			}
		}

		.liebs {
			.tup {
				width: 2.46rem;
				height: 1.59rem;
				border-radius: 10px;
			}
		}

		.xuanzeqi.is-active,
		.xuanzeqi:hover,
		.xuanzeqi.is-focus .el-input__inner {
			border-color: #E71218 !important;
		}
	}

	// ==========================================================================================================================================================================
	// 响应式
	@media screen and (max-width: 767px) {
		.myOrder .orderBox {
			padding: .3rem;
		}
		.myOrder{
			.order_anniu{
				width:100%;
				flex-wrap: wrap;
				
			}
			.biaotie{
				width:100%
			}
			.userreplies-right-btn{
				// width:100%
			}
			
		}
		.myOrder .contrls .resou-sign {
			width: 100%;
			margin-top: .3rem;
		}

		.myOrder .liebs .tup {
			width: 48%;
			height: auto;
		}
	}
</style>